import { useEffect, useState } from "react";
import Sortable from "react-sortablejs";

import { GripVertical, XIcon } from "lucide-react";
import { Button } from "twyne-new.ui";

import { formatters } from '../utils';

const Wrapper = ({ children, item, isSortable }) => isSortable ? <li className='list-unstyled' data-id={item}>{children}</li> : <div>{children}</div>;

function SortableFieldsItem({ item, index, onRemove, id }) {
  const itemParsed = formatters.groupsText(item)
  const isSortable = id === 'groupby'

  return <>
    <Wrapper isSortable={isSortable} item={item}>
      <div className='flex items-center'>
        {isSortable && <>
          <Button color='accent' size='sm' className='rounded-r-none'>
            <GripVertical size={12} />
          </Button>
        </>}
        <Button color='accent' size='sm' className='rounded-r-none rounded-l-none capitalize'>
          {itemParsed}
        </Button>
        <Button color='accent' size='sm' className='rounded-l-none' onClick={onRemove(index)}>
          <XIcon size={12} />
        </Button>
      </div>
    </Wrapper>
  </>
}

function SortableFields({ fields, onChangeOrder, onRemove, id }) {
  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(fields)
  }, [fields])

  const onChangeSortable = order => {
    setItems(order)
    onChangeOrder(order)
  }

  return <Sortable className="flex flex-wrap gap-2" tag="ul" onChange={order => onChangeSortable(order)}>
    {items.map((item, index) => <>
      <SortableFieldsItem
        key={index}
        index={index}
        item={item}
        onRemove={onRemove}
        id={id}
      />
    </>)}
  </Sortable>
}

export default SortableFields
